import { debounce } from "lodash";
import { useEffect, useRef, useState } from "react";
import CustomTextField from "../CustomTextField";
import RenderSitemapLinks from "../RenderSitemapLinks";
import classes from "./jobsByCitiesContent.module.css";

const JobsByCityContent = props => {
  const { sitemapPageData } = props;
  const [searchResults, setSearchResults] = useState(sitemapPageData);
  const inputRef = useRef();
  const onCitySearch = debounce(cityInput => {
    const newSearchResults = JSON.parse(JSON.stringify(sitemapPageData));
    const query = cityInput.target.value.toLowerCase().trim();
    const [cityData] = newSearchResults;
    const { result = [] } = cityData || {};
    const { links = [] } = result[0] || {};
    const filteredCities = links.filter(city =>
      city.displayPlaceholder?.toLowerCase().includes(query)
    );
    cityData.result[0].links = filteredCities;
    setSearchResults(newSearchResults);
  }, 300);
  const [cityData] = searchResults;
  const { result = [] } = cityData || {};
  const { links = [] } = result[0] || {};
  const onSearchAgainClick = () => {
    setSearchResults(sitemapPageData);
    inputRef.current.value = "";
  };
  return (
    <div>
      <div className={classes.headerCnt}>
        <h1>Explore candidates by cities</h1>
        <CustomTextField // this wasn't used please check the design if reused
          placeholder={"Enter city name"}
          onChange={onCitySearch}
          className={classes.textField}
          inputClass={classes.customClass}
          inputRef={inputRef}
          endAdornment={
            <img
              src="/hire/searchIcon.svg"
              height={16}
              width={16}
              alt="search"
              className={classes.textFieldSearchIcon}
            />
          }
        />
      </div>
      {links.length ? (
        <div className={classes.linksContainer}>
          {searchResults.map((data, index) => (
            <RenderSitemapLinks
              key={index}
              data={data}
              showHeading={false}
              anchorDisplayKey={"displayPlaceholder"}
              anchorTitleKey="title"
            />
          ))}
        </div>
      ) : (
        <div className={classes.zeroResultsCnt}>
          <img
            src="/hire/blue-search-icon.svg"
            width={87}
            height={85}
            alt="blue search icon"
          />
          <h1>No results found</h1>
          <h2>
            We're not available in this city yet, but we’ll be launching soon.
            Stay tuned!
          </h2>
          <button onClick={onSearchAgainClick}>Search again</button>
        </div>
      )}
    </div>
  );
};

export default JobsByCityContent;
